import { api } from './client';
import type { Capabilities } from './types';

/**
 * `GET /admin/capabilities`: the bootstrap document the console configures itself from —
 * the deployment's content locales and publish gate, and per collection whether it is
 * hand-ordered and which surfaces it is placed on. Any signed-in actor may read it; the body
 * is filtered to what the caller may do.
 */
export function getCapabilities(): Promise<Capabilities> {
  return api.get<Capabilities>('/admin/capabilities');
}

/** The locale set changes with a deployment, not with a request: one fetch per session. */
export const CAPABILITIES_STALE_MS = 5 * 60_000;
